// extracted by mini-css-extract-plugin
export var marginTop = "OurNumbersSection-module--marginTop--LC_Lu";